import { createRef, useCallback } from 'react'
import { BottomSheetModal } from '@gorhom/bottom-sheet'

export const shareSheetModalRef = createRef<BottomSheetModal>()

export const useShareSheet = () => {
  const open = useCallback(() => {
    shareSheetModalRef.current?.present()
  }, [])

  const close = useCallback(() => {
    console.log('LOG: > useShareSheet > close:')
    shareSheetModalRef.current?.close()
  }, [])

  return {
    ref: shareSheetModalRef,
    open,
    close
  }
}
